import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import 'date-fns';
// import { useFormik } from "formik";
import * as React from 'react';
import { MemberService } from '../../../remote-api/api/member-services';
import { EO2V2Autocomplete } from '../../../shared-components';
import { Autocomplete } from '@material-ui/lab';
import { ClientTypeService, PlanService } from '../../../remote-api/eo2v2-remote-api';
import { map, switchMap } from 'rxjs';
import { Box } from '@material-ui/core';

const memberservice = new MemberService();
const planservice = new PlanService();
const clienttypeervice = new ClientTypeService();

let ps$ = planservice.getPlans();

export default function MemberTemplateModal(props) {
  console.log(props);

  const previousPlanCode = props?.quotationDetails?.planCode;

  const fullWidth = true;
  const [apiValList, setApiValList] = React.useState(props.apiList.length !== 0 ? props.apiList : []);
  const maxWidth = 'sm';
  const [noOfRows, setNoOfRows] = React.useState(100);
  const [planList, setPlanList] = React.useState([]);
  const [selelctedPlanCode, setSelectedPlanCode] = React.useState('');
  const [quotationDetails, setQuotationDetails] = React.useState(props.quotationDetails ? props.quotationDetails : '');
  const [renewalPolicyId, setRenewalPolicyId] = React.useState(props.renewalPolicyId ? props.renewalPolicyId : '');

  const path = window.location.pathname.split('/');

  console.log(selelctedPlanCode);
  console.log(previousPlanCode);

  const handleModalSubmit = e => {
    let allOk = true;
    let hasAPI = true;
    let payload = [];
    let payload2 = [];
    let payload3 = [];
    let url = '';
    if (apiValList.length === 0) {
      memberservice.downloadTemplate(JSON.stringify(payload3), noOfRows, false).subscribe(res => {
        const { data, headers } = res;
        const fileName = headers['content-disposition'].replace(/\w+; filename=(.*)/, '$1');
        const blob = new Blob([data], { type: headers['content-type'] });
        let dom = document.createElement('a');
        let url = window.URL.createObjectURL(blob);
        dom.href = url;
        dom.download = decodeURI(fileName);
        dom.style.display = 'none';
        document.body.appendChild(dom);
        dom.click();
        dom.parentNode.removeChild(dom);
        window.URL.revokeObjectURL(url);
        handleClose();
      });
    }

    if (apiValList.length !== 0) {
      apiValList.forEach(api => {
        let quryParams = [];
        let pathParams = [];

        let qObj = {};
        let pathObj = {};
        api.pathVaraibles.forEach(ele => {
          if (ele.value === '') {
            //error message
            allOk = false;
          }
          if (ele.value !== '') {
            pathObj[ele.urlPlaceholder] = ele.value;
          }
        });

        api.queryParameters.forEach(ele => {
          // if (!qObj.code) {
          //   qObj.code = [selelctedPlanCode]; // Fallback manually
          // }

          if (!qObj.code) {
            const finalPlanCode = selelctedPlanCode === '' ? previousPlanCode : selelctedPlanCode;
            qObj.code = [finalPlanCode];
          }

          // if (ele.value === '' && ele.required) {
          //   //error message
          //   allOk = false;
          // }
          // if (ele.value !== '') {
          //   qObj[ele.urlPlaceholder] = [ele.value];
          // }
        });

        if (quotationDetails && quotationDetails.renewalPolicyId) {
          let policyObj = {
            policyId: [quotationDetails.renewalPolicyId],
          };
          payload3.push({
            apiId: api.id,
            queryParameters: { ...qObj, ...policyObj },
            pathVaraibles: pathObj,
          });
        } else if (renewalPolicyId && renewalPolicyId != '') {
          let policyObj = {
            policyId: [renewalPolicyId],
          };
          payload3.push({
            apiId: api.id,
            queryParameters: { ...qObj, ...policyObj },
            pathVaraibles: pathObj,
          });
        } else {
          payload3.push({
            apiId: api.id,
            queryParameters: (() => {
              const result = qObj.code.filter(val => val !== undefined && val !== null);
              // result.push(props?.policyDetails?.planCode);
              console.log(result, 'result');
              return { code: result };
            })(),
            pathVaraibles: pathObj,
          });
        }
      });

      if (allOk) {
        if ((quotationDetails && quotationDetails?.renewalPolicyId) || (renewalPolicyId && renewalPolicyId != '')) {
          memberservice.downloadTemplate(JSON.stringify(payload3), noOfRows, true).subscribe(res => {
            const { data, headers } = res;
            const fileName = headers['content-disposition'].replace(/\w+; filename=(.*)/, '$1');
            const blob = new Blob([data], { type: headers['content-type'] });
            let dom = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            dom.href = url;
            dom.download = decodeURI(fileName);
            dom.style.display = 'none';
            document.body.appendChild(dom);
            dom.click();
            dom.parentNode.removeChild(dom);
            window.URL.revokeObjectURL(url);
            handleClose();
          });
        } else {
          if (path[1] === 'endorsements') {
            url = memberservice.downloadTemplateEndorsement;
            // payload3[0].queryParameters[0].action = props.action
          } else {
            url = memberservice.downloadTemplate;
          }
          url(JSON.stringify(payload3), noOfRows, false, props.action).subscribe(res => {
            const { data, headers } = res;
            const fileName = headers['content-disposition'].replace(/\w+; filename=(.*)/, '$1');
            const blob = new Blob([data], { type: headers['content-type'] });
            let dom = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            dom.href = url;
            dom.download = decodeURI(fileName);
            dom.style.display = 'none';
            document.body.appendChild(dom);
            dom.click();
            dom.parentNode.removeChild(dom);
            window.URL.revokeObjectURL(url);
            handleClose();
          });
        }

        // var blob = new Blob([res], { type: "" });

        //   var blob = new Blob([s2ab(atob(data))],{
        //     type: ''
        // });
      }
    }

    // props.handleBlacklistSubmit(payload);
  };

  const s2ab = s => {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    props.closeTemplateModal();
  };

  const handleQueryParamChange = (e, i, j) => {
    let list = [...apiValList];
    list[i]['queryParameters'][j]['value'] = e.target.value;
    setApiValList(list);
  };

  const handlePathParamChange = (e, i, j) => {
    let list = [...apiValList];
    list[i]['pathVaraibles'][j]['value'] = e.target.value;
    setApiValList(list);
  };
  // const [selectedStartDate, setSelectedStartDate] = React.useState(new Date());
  // const handleStartDateChange = (date) => {
  //     setSelectedStartDate(date);
  //     const timestamp = new Date(date).getTime();
  //     formik.setFieldValue('startDate', timestamp);
  // };

  const handleRowInput = e => {
    setNoOfRows(e.target.value);
  };

  const useObservable = (observable, setter) => {
    React.useEffect(() => {
      let subscription = observable.subscribe(result => {
        setter(result.content);
      });
      return () => subscription.unsubscribe();
    }, [observable, setter]);
  };

  useObservable(ps$, setPlanList);

  const dataSource$ = (
    pageRequest = {
      page: 0,
      size: 10,
      summary: true,
      active: true,
    },
  ) => {
    pageRequest.sort = ['rowLastUpdatedDate dsc'];
    if (pageRequest.searchKey) {
      pageRequest['name'] = pageRequest.searchKey.trim();
    }
    return planservice.getPlans(pageRequest).pipe(
      map(data => {
        let content = data.content;

        let records = content.map(item => {
          let cat = [];
          if (item.planCategorys.length !== 0) {
            item.planCategorys.forEach(ele => {
              cat.push(ele.name);
            });
          }
          item['category'] = cat;
          return item;
        });
        data.content = records;
        console.log(data);

        return data;
      }),
    );
  };

  console.log('selelctedPlanCodeselelctedPlanCodeselelctedPlanCode', selelctedPlanCode);

  return (
    <Dialog
      open={props.openTemplate}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby="form-dialog-title"
      disableEnforceFocus>
      <DialogTitle id="form-dialog-title">Member Template Input</DialogTitle>
      <DialogContent>
        <form onSubmit={handleModalSubmit}>
          {/* <Box>
            <Grid item xs={4}>
              <EO2V2Autocomplete
                id="plan-select"
                name="plan"
                label="Select Plan"
                multiple={false}
                displayKey="name" // 👈 to show 'name'
                $dataSource={(pageRequest, { type, searchText }) => dataSource$({ ...pageRequest, searchKey: searchText })}
                onChange={(e, selectedCode) => {
                  setSelectedPlanCode(selectedCode?.code);
                }}
              />
            </Grid>
            <Grid container spacing={3} style={{ marginBottom: '20px', display: 'flex', flexDirection: 'row' }}>
              {apiValList.map((x, i) => {
                return (
                  <>
                    {x.pathVaraibles.map((y, j) => {
                      return (
                        <Grid item xs={12} sm={6} className="p-2">
                          <TextField
                            id="standard-basic"
                            fullWidth
                            name={y.urlPlaceholder}
                            value={y.value}
                            onChange={e => handlePathParamChange(e, i, j)}
                            label={y.alias}
                            required={true}
                          />
                        </Grid>
                      );
                    })}
                    {x.queryParameters.map((y, j) => {
                      return (
                        <Grid item xs={12} sm={6} className="p-2">
                          <TextField
                            fullWidth
                            id="standard-basic"
                            name={y.urlPlaceholder}
                            // value={y.value}
                            // value={props?.policyDetails?.planCode}
                            value={selelctedPlanCode}
                            onChange={e => handleQueryParamChange(e, i, j)}
                            label={y.alias}
                            required={y.required}
                          />
                        </Grid>
                      );
                    })}
                  </>
                );
              })}
              <Grid item xs={12} sm={6} className="p-2">
                <TextField
                  id="standard-basic"
                  name="noOfRows"
                  fullWidth
                  value={noOfRows}
                  onChange={e => handleRowInput(e)}
                  label="Number of Rows"
                  required={true}
                />
              </Grid>
            </Grid>
          </Box> */}
          <Box sx={{ width: '100%', padding: 2 }}>
            <Grid container spacing={2} alignItems="center">
              {/* Autocomplete */}
              <Grid item xs={12} sm={6} md={4}>
                <EO2V2Autocomplete
                  id="plan-select"
                  name="plan"
                  label="Select Plan"
                  multiple={false}
                  displayKey="name"
                  $dataSource={(pageRequest, { type, searchText }) => dataSource$({ ...pageRequest, searchKey: searchText })}
                  onChange={(e, selectedCode) => {
                    setSelectedPlanCode(selectedCode?.code);
                  }}
                />
              </Grid>

              {/* Dynamic Form Fields */}
              {apiValList.map((x, i) => (
                <React.Fragment key={i}>
                  {x.pathVaraibles.map((y, j) => (
                    <Grid item xs={12} sm={6} md={4} key={`path-${i}-${j}`}>
                      <TextField
                        fullWidth
                        name={y.urlPlaceholder}
                        value={y.value}
                        onChange={e => handlePathParamChange(e, i, j)}
                        label={y.alias}
                        required
                      />
                    </Grid>
                  ))}
                  {x.queryParameters.map((y, j) => (
                    <Grid item xs={12} sm={6} md={4} key={`query-${i}-${j}`}>
                      <TextField
                        fullWidth
                        name={y.urlPlaceholder}
                        // value={previousPlanCode === undefined ? selelctedPlanCode : previousPlanCode}
                        value={previousPlanCode ?? selelctedPlanCode}
                        // value={y.value}
                        onChange={e => handleQueryParamChange(e, i, j)}
                        label={y.alias}
                        required={y.required}
                        // placeholder={previousPlanCode}
                      />
                    </Grid>
                  ))}
                </React.Fragment>
              ))}

              {/* Number of Rows Input */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  name="noOfRows"
                  value={noOfRows}
                  onChange={e => handleRowInput(e)}
                  label="Number of Rows"
                  required
                />
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleModalSubmit} color="secondary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
